import React from "react"
import Helmet from "react-helmet"

export default ({
  cardType = "summary_large_image",
  username = null,
  title = null,
  description = null,
  image = null,
}) => (
  <Helmet>
    <meta name="twitter:card" content={cardType} />
    {<meta name="twitter:creator" content={username} />}
    {<meta name="twitter:title" content={title} />}
    {<meta name="twitter:description" content={description} />}
    {<meta name="twitter:image" content={image} />}
  </Helmet>
)
